import {
  ComponentLinkItem,
  ComponentLinkItemNarrow,
} from '../shared/component-parts';
import { ViewProps } from '../link/link.constants';
import { COMPONENT_LAYOUT_LIST } from 'global/constants';

const WebToolView = (props: ViewProps & { onStimulusOpen?: () => void }) => {
  if (!props.stimulusResourceProperties) return null;

  const componentLinkItemProps = {
    primaryText: props.stimulusResourceProperties.resourceName,
    squareImage: props.stimulusResourceProperties.coverImage,
    link: props.stimulusResourceProperties.link,
    onClick: props.onStimulusOpen,
  };

  return (
    <>
      {props.properties.layout?.display === COMPONENT_LAYOUT_LIST ? (
        <ComponentLinkItemNarrow {...componentLinkItemProps} />
      ) : (
        <ComponentLinkItem {...componentLinkItemProps} />
      )}
    </>
  );
};

export default WebToolView;
